import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import AOS from "aos";
import 'aos/dist/aos.css';


import Portfolio from './pages/Portfolio';
import Jobs from './pages/Jobs';
import Articles from './pages/Articles';
import Modal from './components/Modal';
import ContactFormModal from './components/ContactFormModal';
import './styles/App.css';

function App() {
    useEffect(() => {
    AOS.init();
  }, []);

  const [activeModal, setActiveModal] = useState(null);
  const [showContactForm, setShowContactForm] = useState(false);

  const openModal = (modalType) => {
    setActiveModal(modalType);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setActiveModal(null);
    document.body.style.overflow = 'auto';
  };

  const openContactForm = () => {
    setShowContactForm(true);
    document.body.style.overflow = 'hidden';
  };

  const closeContactForm = () => {
    setShowContactForm(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <Router>
      <div className="App">
        <Navigation />
        
        <Routes>
          <Route path="/" element={<Home onContactClick={openContactForm} />} />
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio onContactClick={openContactForm} />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/articles" element={<Articles />} />
        </Routes>

        <Footer openModal={openModal} onContactClick={openContactForm} />

        {activeModal && (
          <Modal type={activeModal} onClose={closeModal} />
        )}

        {showContactForm && (
          <ContactFormModal onClose={closeContactForm} />
        )}
      </div>
    </Router>
  );
}

export default App;
